import localizationData from "./plains.en.json";
import localized from "model/events/util";

const events = (context, setEvent) =>
  [
    {
      title: "event.wildfire.title",
      isBuild: true,
      baseWeight: 25,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.wildfire.spring.day.description",
            effect: {
              resources: {
                health: -5,
                water: -10,
              },
            },
            weightAdjustment: 10,
          },
          night: {
            description: "event.wildfire.spring.night.description",
            effect: {
              resources: {
                health: -10,
              },
              traits: {
                resilience: +1,
              },
            },
            weightAdjustment: 15,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.wildfire.summer.day.description",
            effect: {
              resources: {
                health: -8,
                water: -15,
                food: -5,
              },
            },
            weightAdjustment: 5,
          },
          night: {
            description: "event.wildfire.summer.night.description",
            effect: {
              resources: {
                health: -12,
                water: -20,
              },
              traits: {
                stealth: +1,
              },
            },
            weightAdjustment: 10,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.wildfire.autumn.day.description",
            effect: {
              resources: {
                health: -10,
                water: -15,
                food: -10,
              },
              traits: {
                infamy: +1,
              },
            },
            weightAdjustment: 0,
          },
          night: {
            description: "event.wildfire.autumn.night.description",
            effect: {
              resources: {
                health: -15,
                water: -20,
              },
            },
            weightAdjustment: 5,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.wildfire.winter.day.description",
            effect: {
              resources: {
                health: -5,
                ammo: -5,
              },
            },
            weightAdjustment: -10,
          },
          night: {
            description: "event.wildfire.winter.night.description",
            effect: {
              resources: {
                health: -10,
                ammo: -10,
              },
              traits: {
                luck: -1,
              },
            },
            weightAdjustment: -5,
          },
        },
      ],
      buttons: [
        {
          title: "event.wildfire.button.flee",
          message: "event.wildfire.button.message.flee",
          effect: { resources: { health: -2 } },
        },
        {
          title: "event.wildfire.button.fight",
          message: "event.wildfire.button.message.fight",
          effect: {
            resources: { health: -10, water: -10 },
            traits: { resilience: +1 },
          },
        },
      ],
    },
    {
      title: "event.wildlifeEncounter.title",
      outcome: "variable",
      state: "isIn",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.wildlifeEncounter.spring.day.description",
            effect: {
              resources: { food: +10 },
              traits: { stealth: +1 },
            },
            weightAdjustment: 0,
          },
          night: {
            description: "event.wildlifeEncounter.spring.night.description",
            effect: { resources: { food: +5 }, traits: { luck: +1 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.wildlifeEncounter.summer.day.description",
            effect: {
              resources: { water: +5 },
              traits: { resilience: +1 },
            },
            weightAdjustment: -5,
          },
          night: {
            description: "event.wildlifeEncounter.summer.night.description",
            effect: {
              resources: { morale: +1 },
              traits: { charisma: +1 },
            },
            weightAdjustment: 0,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.wildlifeEncounter.autumn.day.description",
            effect: {
              resources: { ammo: -5 },
              traits: { haggling: +1 },
            },
            weightAdjustment: 5,
          },
          night: {
            description: "event.wildlifeEncounter.autumn.night.description",
            effect: {
              resources: { health: -5 },
              traits: { resilience: +1 },
            },
            weightAdjustment: 10,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.wildlifeEncounter.winter.day.description",
            effect: { resources: { food: +5 }, traits: { luck: +1 } },
            weightAdjustment: 10,
          },
          night: {
            description: "event.wildlifeEncounter.winter.night.description",
            effect: {
              resources: { food: +2 },
              traits: { stealth: +1 },
            },
            weightAdjustment: 15,
          },
        },
      ],
      buttons: [
        {
          title: "event.wildlifeEncounter.button.interact",
          message: "event.wildlifeEncounter.button.message.interact",
          effect: {},
        },
        {
          title: "event.wildlifeEncounter.button.avoid",
          message: "event.wildlifeEncounter.button.message.avoid",
          effect: {},
          isDismiss: true,
        },
      ],
    },
    {
      title: "event.weather.title",
      outcome: "variable",
      isBuild: true,
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.weather.spring.day.description",
            effect: {
              resources: { morale: +1 },
              traits: { resilience: +1 },
            },
            weightAdjustment: 0,
          },
          night: {
            description: "event.weather.spring.night.description",
            effect: { resources: { morale: -1 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.weather.summer.day.description",
            effect: { resources: { water: -5 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.weather.summer.night.description",
            effect: { resources: { food: -5 }, traits: { luck: +1 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.weather.autumn.day.description",
            effect: {
              resources: { ammo: -2 },
              traits: { haggling: +1 },
            },
            weightAdjustment: 5,
          },
          night: {
            description: "event.weather.autumn.night.description",
            effect: { resources: { health: -5 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.weather.winter.day.description",
            effect: {
              resources: { food: -10 },
              traits: { resilience: +1 },
            },
            weightAdjustment: 10,
          },
          night: {
            description: "event.weather.winter.night.description",
            effect: {
              resources: { health: -10 },
              traits: { stealth: +1 },
            },
            weightAdjustment: 15,
          },
        },
      ],
      buttons: [
        {
          title: "event.weather.button.endure",
          message: "event.weather.button.message.endure",
          effect: { resources: { health: -2, morale: -5 } },
        },
        {
          title: "event.weather.button.seekShelter",
          message: "event.weather.button.message.seekShelter",
          effect: { resources: { health: -5 }, traits: { resilience: 1 } },
        },
      ],
    },
    {
      title: "event.trailObstruction.title",
      outcome: "negative",
      isBuild: true,
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.trailObstruction.spring.day.description",
            effect: { calendar: { time: -1 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.trailObstruction.spring.night.description",
            effect: { calendar: { time: -2 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.trailObstruction.summer.day.description",
            effect: { calendar: { time: -1 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.trailObstruction.summer.night.description",
            effect: { calendar: { time: -2 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.trailObstruction.autumn.day.description",
            effect: { calendar: { time: -1 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.trailObstruction.autumn.night.description",
            effect: { calendar: { time: -2 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.trailObstruction.winter.day.description",
            effect: { calendar: { time: -1 } },
            weightAdjustment: 10,
          },
          night: {
            description: "event.trailObstruction.winter.night.description",
            effect: { calendar: { time: -2 } },
            weightAdjustment: 15,
          },
        },
      ],
      buttons: [
        {
          title: "event.trailObstruction.button.clear",
          message: "event.trailObstruction.button.message.clear",
          effect: {
            resources: { health: -5, ammo: -2 },
            traits: { resilience: +1 },
          },
        },
        {
          title: "event.trailObstruction.button.detour",
          message: "event.trailObstruction.button.message.detour",
          effect: { resources: { food: -5, morale: -2 } },
        },
      ],
    },
    {
      title: "event.ambush.title",
      outcome: "negative",
      isCombat: true,
      baseWeight: 30,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.ambush.spring.day.description",
            effect: { resources: { health: -5, ammo: -10 } },
            enemies: ["bandit", "bandit", "bandit"],
            weightAdjustment: 0,
          },
          night: {
            description: "event.ambush.spring.night.description",
            effect: { resources: { health: -10, ammo: -15 } },
            enemies: ["bandit", "bandit", "bandit"],
            weightAdjustment: 5,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.ambush.summer.day.description",
            effect: { resources: { health: -5, ammo: -10 } },
            enemies: ["raider", "raider", "raider"],
            weightAdjustment: -5,
          },
          night: {
            description: "event.ambush.summer.night.description",
            effect: { resources: { health: -10, ammo: -15 } },
            enemies: ["raider", "raider", "raider"],
            weightAdjustment: 0,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.ambush.autumn.day.description",
            effect: { resources: { health: -5, ammo: -10 } },
            enemies: ["tribesman", "tribesman"],
            weightAdjustment: 5,
          },
          night: {
            description: "event.ambush.autumn.night.description",
            effect: { resources: { health: -10, ammo: -15 } },
            enemies: ["tribesman", "tribesman"],
            weightAdjustment: 10,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.ambush.winter.day.description",
            effect: { resources: { health: -5, ammo: -10 } },
            enemies: ["wolf", "wolf", "wolf"],
            weightAdjustment: 10,
          },
          night: {
            description: "event.ambush.winter.night.description",
            effect: { resources: { health: -10, ammo: -15 } },
            enemies: ["wolf", "wolf", "wolf"],
            weightAdjustment: 15,
          },
        },
      ],
      buttons: [
        {
          title: "event.ambush.button.fightBack",
          combat: {
            description: "event.ambush.button.fightBack.description",
            victory: "event.ambush.button.fightBack.victory",
            defeat: "event.ambush.button.fightBack.defeat",
            enemies: [],
          },
        },
        {
          title: "event.ambush.button.escape",
          message: "event.ambush.button.message.escape",
          effect: {},
        },
      ],
    },
    {
      title: "event.travelersEncounter.title",
      outcome: "variable",
      state: "encountered",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.travelersEncounter.spring.day.description",
            effect: { resources: { morale: +1, food: +5 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.travelersEncounter.spring.night.description",
            effect: { resources: { morale: +2 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.travelersEncounter.summer.day.description",
            effect: { resources: { water: +10 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.travelersEncounter.summer.night.description",
            effect: { resources: { ammo: +5 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.travelersEncounter.autumn.day.description",
            effect: { resources: { coins: +15 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.travelersEncounter.autumn.night.description",
            effect: { resources: { coins: +20 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.travelersEncounter.winter.day.description",
            effect: { resources: { health: +5 } },
            weightAdjustment: 10,
          },
          night: {
            description: "event.travelersEncounter.winter.night.description",
            effect: { resources: { health: +10 } },
            weightAdjustment: 15,
          },
        },
      ],
      buttons: [
        {
          title: "event.travelersEncounter.button.trade",
          message: "event.travelersEncounter.button.message.trade",
          effect: { resources: { coins: -5 } },
        },
        {
          title: "event.travelersEncounter.button.shareStories",
          message: "event.travelersEncounter.button.message.shareStories",
          effect: { resources: { morale: +1 } },
        },
      ],
    },
    {
      title: "event.naturalHazards.title",
      outcome: "negative",
      isBuild: true,
      baseWeight: 25,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.naturalHazards.spring.day.description",
            effect: { resources: { health: -5 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.naturalHazards.spring.night.description",
            effect: { resources: { health: -10 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.naturalHazards.summer.day.description",
            effect: { resources: { water: -10 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.naturalHazards.summer.night.description",
            effect: { resources: { water: -5 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.naturalHazards.autumn.day.description",
            effect: { resources: { food: -5 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.naturalHazards.autumn.night.description",
            effect: { resources: { food: -10 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.naturalHazards.winter.day.description",
            effect: { resources: { ammo: -5 } },
            weightAdjustment: 10,
          },
          night: {
            description: "event.naturalHazards.winter.night.description",
            effect: { resources: { ammo: -10 } },
            weightAdjustment: 15,
          },
        },
      ],
      buttons: [
        {
          title: "event.naturalHazards.button.seekShelter",
          message: "event.naturalHazards.button.message.seekShelter",
          effect: { resources: { health: +5 } },
        },
        {
          title: "event.naturalHazards.button.pressOn",
          message: "event.naturalHazards.button.message.pressOn",
          effect: { resources: { health: -5 }, traits: { resilience: +1 } },
        },
      ],
    },
    {
      title: "event.plainsEncounter.title",
      isCombat: true,
      baseWeight: 25,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.plainsEncounter.spring.day.description",
            effect: { resources: { health: -5, ammo: -2 } },
            enemies: ["cougar"],
            weightAdjustment: 5,
          },
          night: {
            description: "event.plainsEncounter.spring.night.description",
            effect: {
              resources: { morale: -1 },
              traits: { stealth: -1 },
            },
            enemies: ["wolf", "wolf"],
            weightAdjustment: 10,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.plainsEncounter.summer.day.description",
            effect: { resources: { water: -3 } },
            enemies: ["elk"],
            weightAdjustment: -5,
          },
          night: {
            description: "event.plainsEncounter.summer.night.description",
            effect: { traits: { luck: +1 } },
            enemies: ["raider"],
            weightAdjustment: 5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.plainsEncounter.autumn.day.description",
            effect: { resources: { food: -4 } },
            enemies: ["moose"],
            weightAdjustment: 0,
          },
          night: {
            description: "event.resources.autumn.night.description",
            effect: {
              resources: { health: -7 },
              traits: { resilience: +1 },
            },
            enemies: ["cougar", "cougar"],
            weightAdjustment: 15,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.plainsEncounter.winter.day.description",
            effect: { resources: { ammo: -3, food: +5 } },
            enemies: ["wolf", "wolf", "wolf"],
            weightAdjustment: -10,
          },
          night: {
            description: "event.plainsEncounter.winter.night.description",
            effect: {
              resources: { coins: -5 },
              traits: { charisma: -1 },
            },
            enemies: ["wolf", "wolf", "wolf"],
            weightAdjustment: -5,
          },
        },
      ],
      buttons: [
        {
          title: "event.plainsEncounter.button.fight",
          combat: {
            description: "event.plainsEncounter.button.fight.description",
            victory: "event.plainsEncounter.button.fight.victory",
            defeat: "event.plainsEncounter.button.fight.defeat",
            enemies: [],
          },
        },
        {
          title: "event.plainsEncounter.button.evade",
          message: "event.plainsEncounter.button.evade.message",
        },
      ],
    },
  ].map((event) => localized(event, localizationData));

export default events;
